/**
 * FeaturePath: 會員系統-其它-廣告-公告訊息
 * Accountable: AlexCH Cheng, Landy Chu
 */

/**
 * 設定公告訊息
 */
export const SET_POPUPS = 'SET_POPUPS';
